const getLetsFormDesignerUrl = () => {
  return process.env.NODE_ENV === 'development' ?
  process.env.REACT_APP_DEVELOPMENT_LETS_FORM_DESIGNER_SITE : process.env.REACT_APP_PRODUCTION_LETS_FORM_DESIGNER_SITE;
}

export const getPlaygroundIframe = ({ shareCode, name, height }) =>
  `<iframe src="${getLetsFormDesignerUrl()}/p/${shareCode}" title="${name}" style="border:none;" width="100%" height="${height ?? 350}"></iframe>`